import React, { useEffect, useState } from "react";
import ModalCalendar from "../../../../features/ModalCalendar";
import ReadMore from "../../../../features/ReadMore";
import { Exercise } from "../../../models/Exercise";
import useCalendarSale from "../../ThreeStep/hooks/useCalendarSale";
import CalendarModal from "../CalendarModal/CalendarModal";

import "./style.scss";
import { Link, useNavigate } from "react-router-dom";
import { MODAL_TEST } from "../../../routes";
import ModalWindow from "../../ModalWindow";
import { setExerciseName, setExerciseZoneId } from "../../../store/pseudoModal/pseudoModalsActions";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "../../../../features/Loading/LoadingSpinner";
import LightBox from "../../../../features/LightBox";
import { useTranslation } from "react-i18next";
import { State } from "../../../store";
import useCountHtmlTagCharacters from "../../../../utils/hooks/useCountHtmlTagCharacters";


interface IProps {
  exercise: Exercise;
}

const SingleAvailAbleExercise: React.FC<IProps> = ({ exercise }: IProps) => {
  const { t } = useTranslation();
  const ids = useSelector((state: State) => state.config.facilityIds);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openLightBox, setOpenLightBox] = useState(false);
  const { getTicketsByExercise, tickets } = useCalendarSale();
  const { countHtmlTagCharacters } = useCountHtmlTagCharacters();
  const state = {
    post: [],
  };
  useEffect(() => {
    getTicketsByExercise(exercise.exerciseGroup.objectId, exercise);
  }, []);
  const dispatch = useDispatch();
  const lowestPrice = tickets.reduce((r, b) => Math.min(r, b.price), Number.POSITIVE_INFINITY);

  const updateState = () => {
    navigate(
      `${MODAL_TEST}?id=${ids}&exerciseName=${exercise.name.replace(/%/g, "%25")}&exerciseIds=${exercise.zone.objectId}`
    );
    dispatch(setExerciseName(exercise.name));
    dispatch(setExerciseZoneId(exercise.zone.objectId));
    window.parent.postMessage("scroll::", "*");
  };

  return (
    <div className="single-available-exercise shadow flex-between-center border">
      <div
        style={{ backgroundImage: `url(${exercise.eventMessage})` }}
        className="single-available-exercise-img"
        onClick={() => setOpenLightBox(!openLightBox)}
      ></div>

      <div className="single-available-exercise-text readmore-left">
        <h2>{exercise.name}</h2>
        {exercise.description.length > 160 + countHtmlTagCharacters(exercise.description) ? (
          <ReadMore text={exercise.description} minLengthText={160 + countHtmlTagCharacters(exercise.description)} title={exercise.name} />
        ) : (
          <article dangerouslySetInnerHTML={{ __html: exercise.description }}></article>
        )}
      </div>

      <div className="single-available-exercise-buttons flex-column">
        <b>
          {lowestPrice !== Infinity ? (
            <React.Fragment>
              {t("ceny_od")} {lowestPrice} {t("zl")}
            </React.Fragment>
          ) : (
            <LoadingSpinner />
          )}
        </b>
        <button className="button medium padding-medium button-fill-main full-button" onClick={() => updateState()}>
          {t("wybierz")}
        </button>
      </div>

      {openLightBox && (
        <LightBox
          imageUrl={exercise.eventMessage}
          open={openLightBox}
          closeModal={() => setOpenLightBox(false)}
          onAccept={() => {}}
        ></LightBox>
      )}

      {open && (
        <ModalWindow />

        // <ModalCalendar
        // footer={false}
        //   open={open}
        //   closeModal={() => setOpen(false)}
        //   title={exercise.name}
        //   onAccept={() => {}}
        // >
        //     <CalendarModal  exerciseName={exercise.name} zone={exercise.zone.objectId} ></CalendarModal>
        // </ModalCalendar>
      )}
    </div>
  );
};

export default SingleAvailAbleExercise;
